import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Row,
  Col,
  Divider,
  Card,
  Button,
  Input,
  notification,
} from "antd";
import Loading from "../../common/Loading";
import { noAuthadd } from "../../api/Apis";
import tracyPic from "../../images/tracy2.jpeg";
const { TextArea } = Input;

const EMPTY_FORM = { name: "", email: "", phone: "", message: "", loading: false };

export default class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.contacts = [
      {
        key: "tracy",
        photo: tracyPic,
        name: "Tracy Barber, Founder",
        company: "That's My Town, Inc.",
        address: "228 Worcester Road, Westminster, MA 01473",
        phone: "(978) 400-1617",
        email: "trbarber10@msn.com",
        bio:
          "Home Buddha was founded by Tracy Barber, a dedicated real estate expert whose career has been built on guiding people through one of the most important decisions of their lives—buying, selling, and caring for their homes. With years of hands-on experience and a reputation for putting clients first, Tracy has helped countless individuals and families navigate the complexities of the real estate market with confidence and clarity. Through his work, Tracy recognized that homeownership doesn’t end at the closing table. Many homeowners are left without the tools, knowledge, or systems to truly manage, maintain, and maximize their investment. Driven by a desire to change that experience, Tracy founded Home Buddha to create a more thoughtful, empowering approach to homeownership—one that supports homeowners at every stage of their journey and helps people live happier, healthier, and wealthier lives through smarter homeownership.",
      },
      {
        key: "brian",
        photo:
          "https://assets.cdn.filesafe.space/bZI6dyyFAn2ZSD9YUdpT/media/6a57e160c06d2134c6d3ac73.jpeg",
        name: "Brian Vocino, Director of Partnerships",
        company: "That's My Town, Inc.",
        phone: "(617) 797-0181",
        email: "Bvocino@yahoo.com",
        bio:
          "Brian Vocino is a seasoned business development executive and strategic growth leader with more than 25 years of experience driving revenue, partnerships, and market expansion across the financial services and healthcare sectors. A graduate of the Girard School of Business at Merrimack College, Brian has held senior leadership roles—including Vice President of Business Development—at organizations such as Fresenius Medical Care, Teleflex Incorporated, Putnam Investments, and Columbia Management Funds, earning a reputation for forging high-impact partnerships and exceeding ambitious revenue targets. Known for a consultative, solutions-driven approach, Brian prioritizes understanding challenges, building trust, and delivering long-term outcomes over transactions. At Home Buddha, Brian leads business development and go-to-market strategy, expanding partnerships and accelerating growth in service of the company’s mission to create happier, healthier, and more financially empowered homeowners.",
      },
      {
        key: "andrea",
        photo:
          "https://assets.cdn.filesafe.space/bZI6dyyFAn2ZSD9YUdpT/media/6a6a26be9a8605ccbf9ad06f.jpg",
        name: 'Andrea Dicaire, CFO "Chief Fun Officer"',
        company: "That's My Town, Inc.",
        phone: "(413) 406-6793",
        email: "hunterandrea0214@gmail.com",
        bio:
          "Andrea Dicaire brings a rare combination of financial precision and infectious energy to her role as CFO—and self-appointed Chief Fun Officer—at Home Buddha. With a background in corporate finance and operations, Andrea has spent her career helping growing companies build strong financial foundations while making sure the people behind the numbers never lose sight of why the work matters. Before joining Home Buddha, she managed budgets, forecasting, and financial strategy across the real estate and services industries, developing a reputation for turning complex spreadsheets into clear, actionable insight. Andrea believes sound financial stewardship and a positive, energized team culture go hand in hand. At Home Buddha, she oversees the company’s financial health—from budgeting and reporting to long-term planning—while also championing team culture, celebrating wins big and small, and keeping the Home Buddha spirit light, human, and connected as the company grows.",
      },
    ];

    this.state = {
      initialLoading: true,
      forms: {
        tracy: { ...EMPTY_FORM },
        brian: { ...EMPTY_FORM },
        andrea: { ...EMPTY_FORM },
      },
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        initialLoading: false,
      });
    }, 2000);
  };

  handleFormChange = (key, field) => (e) => {
    const value = e.target.value;
    this.setState((prevState) => ({
      forms: {
        ...prevState.forms,
        [key]: {
          ...prevState.forms[key],
          [field]: value,
        },
      },
    }));
  };

  handleResetForm = (key) => {
    this.setState((prevState) => ({
      forms: {
        ...prevState.forms,
        [key]: { ...EMPTY_FORM },
      },
    }));
  };

  handleSendMail = async (key, toEmail, toName) => {
    const form = this.state.forms[key];
    if (!form.email) {
      alert("Please enter email");
      return;
    } else if (!form.message) {
      alert("Please enter message");
      return;
    }

    this.setState((prevState) => ({
      forms: {
        ...prevState.forms,
        [key]: { ...prevState.forms[key], loading: true },
      },
    }));

    const data = {
      entityData: {
        to: toEmail,
        toName: toName,
        from: form.name,
        email: form.email,
        phone: form.phone,
        subject: `New contact form submitted on Home Buddha for ${toName}`,
        message: form.message,
      },
    };

    const response = await noAuthadd("submitContactForm", data);
    if (response.success) {
      this.handleResetForm(key);
      notification["success"]({
        message: "You have successfully sent your message. Thank you.",
      });
    } else {
      this.setState((prevState) => ({
        forms: {
          ...prevState.forms,
          [key]: { ...prevState.forms[key], loading: false },
        },
      }));
      notification["error"]({
        message: "Message sent failed.",
      });
    }
  };

  // Photo + basic info block — mirrors the original Tracy card markup
  // exactly (short sibling text only) so it doesn't interact badly with
  // the site's card image CSS.
  renderPhotoCard = (contact) => {
    return (
      <Row key={`${contact.key}-photo`}>
        <Col span={24} className="card-description">
          <Card
            hoverable
            bordered={false}
            title={null}
            bodyStyle={{ padding: "0px" }}
            style={{
              background: "#FFF",
              borderColor: "black",
              marginTop: "1.5vw",
            }}
            className="padding-card1-whyjoin"
          >
            <Row align="top">
              <Col
                xl={{ span: 8, offset: 0 }}
                lg={{ span: 8, offset: 0 }}
                md={{ span: 8, offset: 0 }}
                sm={{ span: 22, offset: 1 }}
                xs={{ span: 22, offset: 1 }}
                style={{ padding: "20px" }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "220px",
                    margin: "0 auto",
                    paddingBottom: "100%",
                    overflow: "hidden",
                    boxShadow: "0px 0px 10px 0px",
                    border: "6px solid rgb(28, 45, 65)",
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    alt={contact.name.split(",")[0]}
                    src={contact.photo}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
              </Col>
              <Col
                xl={{ span: 14, offset: 2 }}
                lg={{ span: 14, offset: 2 }}
                md={{ span: 14, offset: 2 }}
                sm={{ span: 22, offset: 1 }}
                xs={{ span: 22, offset: 1 }}
                className="card-description"
              >
                <h3 style={{ fontWeight: "bold" }}>{contact.name}</h3>
                <h3>{contact.company}</h3>
                {contact.address && <h3>{contact.address}</h3>}
                <h3>Phone : {contact.phone}</h3>
                <h3 style={{ marginBottom: "15px" }}>
                  Email : {contact.email}
                </h3>
                <p style={{ lineHeight: "1.6", color: "#555", margin: 0 }}>
                  {contact.bio}
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  };

  // Mini contact form — reuses the exact field-row pattern from the
  // original single contact form (proven safe), targeted at this
  // person's email.
  renderFormCard = (contact) => {
    const form = this.state.forms[contact.key];
    const firstName = contact.name.split(",")[0];

    return (
      <Card
        key={`${contact.key}-form`}
        hoverable
        bordered={false}
        title={null}
        bodyStyle={{ padding: "15px" }}
        style={{
          background: "#FFF",
          borderColor: "black",
          marginTop: "1vw",
          marginBottom: "2vw",
        }}
        className="padding-card1-whyjoin"
      >
        <Row className="padding">
          <Col span={24}>
            <h3
              style={{
                fontWeight: "bold",
                marginBottom: "1.5vw",
              }}
            >
              Send {firstName} a Message
            </h3>
          </Col>
        </Row>

        <Row className="padding">
          <Col
            xl={{ span: 4 }}
            lg={{ span: 4 }}
            md={{ span: 4 }}
            xs={{ span: 5 }}
            sm={{ span: 5 }}
          >
            <span className="color-grey terms">Name :</span>
          </Col>
          <Col
            xl={{ span: 18, offset: 2 }}
            lg={{ span: 18, offset: 2 }}
            md={{ span: 18, offset: 2 }}
            xs={{ span: 18, offset: 1 }}
            sm={{ span: 18, offset: 1 }}
          >
            <Input
              name="name"
              placeholder="Enter Your Name"
              className="form-input"
              value={form.name}
              onChange={this.handleFormChange(contact.key, "name")}
              style={{
                border: "1px solid #fff",
                color: "black",
                background: "white",
              }}
            />
          </Col>
        </Row>
        <Divider style={{ margin: "5px" }}></Divider>

        <Row className="padding">
          <Col
            xl={{ span: 4 }}
            lg={{ span: 4 }}
            md={{ span: 4 }}
            xs={{ span: 5 }}
            sm={{ span: 5 }}
          >
            <span className="color-grey terms">Email :</span>
          </Col>
          <Col
            xl={{ span: 18, offset: 2 }}
            lg={{ span: 18, offset: 2 }}
            md={{ span: 18, offset: 2 }}
            xs={{ span: 18, offset: 1 }}
            sm={{ span: 18, offset: 1 }}
          >
            <Input
              name="email"
              placeholder="Enter Your Email"
              className="form-input"
              value={form.email}
              onChange={this.handleFormChange(contact.key, "email")}
              style={{
                border: "1px solid #fff",
                color: "black",
                background: "white",
              }}
            />
          </Col>
        </Row>
        <Divider style={{ margin: "5px" }}></Divider>

        <Row className="padding">
          <Col
            xl={{ span: 4 }}
            lg={{ span: 4 }}
            md={{ span: 4 }}
            xs={{ span: 5 }}
            sm={{ span: 5 }}
          >
            <span className="color-grey terms">Phone :</span>
          </Col>
          <Col
            xl={{ span: 18, offset: 2 }}
            lg={{ span: 18, offset: 2 }}
            md={{ span: 18, offset: 2 }}
            xs={{ span: 18, offset: 1 }}
            sm={{ span: 18, offset: 1 }}
          >
            <Input
              name="phone"
              placeholder="Enter Your Phone"
              className="form-input"
              value={form.phone}
              onChange={this.handleFormChange(contact.key, "phone")}
              style={{
                border: "1px solid #fff",
                color: "black",
                background: "white",
              }}
            />
          </Col>
        </Row>
        <Divider style={{ margin: "5px" }}></Divider>

        <Row className="padding">
          <Col
            xl={{ span: 4 }}
            lg={{ span: 5 }}
            md={{ span: 4 }}
            xs={{ span: 5 }}
            sm={{ span: 5 }}
          >
            <span className="color-grey terms">Message :</span>
          </Col>
          <Col
            xl={{ span: 18, offset: 2 }}
            lg={{ span: 17, offset: 2 }}
            md={{ span: 18, offset: 2 }}
            xs={{ span: 18, offset: 1 }}
            sm={{ span: 18, offset: 1 }}
          >
            <TextArea
              placeholder="Start Typing.."
              rows={3}
              name="message"
              value={form.message}
              onChange={this.handleFormChange(contact.key, "message")}
              style={{ border: "1px solid #fff" }}
            />
          </Col>
        </Row>
        <Divider style={{ margin: "5px" }}></Divider>

        <div style={{ float: "right" }}>
          <Button
            key="submit"
            type="primary"
            loading={form.loading}
            onClick={() =>
              this.handleSendMail(contact.key, contact.email, contact.name)
            }
            className="send-button-mobile-view"
          >
            <h6
              style={{
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "14px",
                marginTop: "5px",
              }}
            >
              Send
            </h6>
          </Button>
        </div>
      </Card>
    );
  };

  renderContactBlock = (contact) => {
    return (
      <div key={contact.key}>
        {this.renderPhotoCard(contact)}
        {this.renderFormCard(contact)}
      </div>
    );
  };

  render() {
    return (
      <div>
        <Loading enableLoading={this.state.initialLoading} />
        <Row>
          <Col span={20} offset={2}>
            <Divider>
              <h1>Contact Us</h1>
            </Divider>
          </Col>
        </Row>

        <Row>
          <Col
            xl={{ span: 20, offset: 2 }}
            lg={{ span: 20, offset: 2 }}
            md={{ span: 22, offset: 1 }}
            sm={{ span: 22, offset: 1 }}
            xs={{ span: 22, offset: 1 }}
          >
            {this.contacts.map((contact) => this.renderContactBlock(contact))}
          </Col>
        </Row>
      </div>
    );
  }
}
